module.exports = __webpack_public_path__ + "static/media/PM147.c320c875.png";